export const CATALOG_FACET_STORAGE_KEY = "catalog.facets";

export const PERSISTED_HASH_FACETS = [
  "taxonomy_markets",
  "taxonomy_industries",
  "taxonomy_applications",
  "taxonomy_solutions",
] as const;

export type PersistedHashFacet = (typeof PERSISTED_HASH_FACETS)[number];
export type PersistedCatalogFacets = Partial<
  Record<PersistedHashFacet, string[]>
>;

export const OFFERING_CATALOG_INHERITED_FACETS: readonly PersistedHashFacet[] =
  ["taxonomy_markets", "taxonomy_industries"] as const;

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === "string");

export const readPersistedCatalogFacets = (): PersistedCatalogFacets => {
  if (typeof window === "undefined") return {};

  try {
    const raw = window.localStorage.getItem(CATALOG_FACET_STORAGE_KEY);
    if (!raw) return {};

    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};

    const source = parsed as Record<string, unknown>;
    const result: PersistedCatalogFacets = {};

    for (const field of PERSISTED_HASH_FACETS) {
      const candidate = source[field];
      if (!isStringArray(candidate)) continue;

      const values = candidate.map((v) => v.trim()).filter((v) => v.length > 0);
      if (values.length > 0) {
        result[field] = values;
      }
    }

    return result;
  } catch {
    return {};
  }
};
